export const mobileRegExp =
  /^(0[0-9]{2,}[0-9]{8,})|(\u06F0[\u06F0-\u06F9]{2,}[\u06F0-\u06F9]{8,})$/;
